import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


export function getWysiwygAlignmentClasses(component: IdtComponent) {
  const classes: string[] = [];

  if (component.settings?.styles?.textPositionVertical) {
    classes.push(`vertical-${component.settings.styles.textPositionVertical}`);
  }

  return classes.join(' ');
}
